import script from "./SearchNav.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchNav.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__